import * as S from "components/common/Banner/Overlay.style";

const Overlay = () => {
  return (
    <S.Overlay>
      <S.TextBanner variant="headline-01" color="white">
        <S.MainInfo>Conformidade e Governança</S.MainInfo>
      </S.TextBanner>
      <S.TextBanner variant="headline-01" color="white">
        <S.SecondaryInfo>Construindo relações de confiança</S.SecondaryInfo>
      </S.TextBanner>
      <S.BannerIndicator />
    </S.Overlay>
  );
};

export default Overlay;
